var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-4"},[_vm._m(0),_c('foodReceiptList')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('span',{staticClass:"main-title"},[_vm._v("ORDER RECEIPT |")]),_c('span',{staticClass:"submain-title"},[_vm._v("Food Delivery receipt")])])
}]

export { render, staticRenderFns }